import { APICall } from "@/config/NetworkUtility";

import { BASE_MODULE_DELETE, BASE_MODULE_INSERT, BASE_MODULE_UPDATE, BASE_MODULES_LIST, BASE_MODULES_PAGINATION } from "./constant";
import { callLoader } from "@/redux/Loader/actions";
import { logApiError } from "@/services/apiErrorLogger";

// ======================================
// GET BASE MODULES
// ======================================

export const getBaseModules = (payload) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const queryParams = new URLSearchParams({
      ...payload,
    }).toString();

    const url = `v1/ModuleSetup/GetBaseModuleList?${queryParams}`;

    const result = await APICall("get", payload, url);

    dispatch(callLoader(false));

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      dispatch({
        type: BASE_MODULES_LIST,
        payload: result?.data || [],
      });

      dispatch({
        type: BASE_MODULES_PAGINATION,
        payload: result?.pagination || {},
      });

      return result?.data || [];
    } else {
      return Promise.reject(result);
    }
  } catch (error) {
    logApiError(error, {
      source: "base modules",
      endpoint: "getBaseModules",
      payload,
    });

    dispatch(callLoader(false));

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};

// ======================================
// GET BASE MODULES DROPDOWN
// ======================================


export const getBaseModuleDropdown = () => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/GetBaseModuleDropdownList`;

    const result = await APICall("get", null, url);

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      return result?.data || [];
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "getBaseModuleDropdown",
      endpoint: "GetBaseModuleDropdownList",
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};

// ======================================
// GET BASE MODULES Type DROPDOWN
// ======================================

export const getBaseModuleTypeDropdown = () => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/GetBaseModuleTypeDropdownList`;

    const result = await APICall("get", null, url);

      if (result?.statuscode === 200 || result?.statuscode === 201) {
         dispatch({
        type: "SET_BASE_MODULE_TYPES",
        payload: result?.data || [],
      });

          
      return result?.data || [];
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "getBaseModuleTypeDropdownList",
      endpoint: "GetBaseModuleTypeDropdownListList",
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};

// ======================================
// INSERT BASE MODULE
// ======================================

export const insertBaseModule =
  (payload) => async (dispatch) => {
    try {
      dispatch(callLoader(true));

      const url = `v1/ModuleSetup/BaseModuleInsert`;

      const result = await APICall(
        "post",
        payload,
        url,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (
        result?.statuscode === 200 ||
        result?.statuscode === 201
      ) {
        dispatch({
          type: BASE_MODULE_INSERT,
          payload: result?.data || result,
        });

        return result;
      }

      return Promise.reject(result);
    } catch (error) {
      logApiError(error, {
        source: "insertBaseModule",
        endpoint: "v1/ModuleSetup/BaseModuleInsert",
        payload: "[FormData]",
      });

      return Promise.reject(error);
    } finally {
      dispatch(callLoader(false));
    }
    };

    
// ======================================
// UPDATE BASE MODULE
// ======================================
  
export const updateBaseModule =
  (payload) => async (dispatch) => {
    try {
      dispatch(callLoader(true));

      const url = `v1/ModuleSetup/BaseModuleUpdate`;

      const result = await APICall(
        "post",
        payload,
        url,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (
        result?.statuscode === 200 ||
        result?.statuscode === 201
      ) {
        dispatch({
          type: BASE_MODULE_UPDATE,
          payload: result?.data || result,
        });

        return result;
      }

      return Promise.reject(result);
    } catch (error) {
      logApiError(error, {
        source: "updateBaseModule",
        endpoint: "v1/ModuleSetup/BaseModuleUpdate",
        payload: "[FormData]",
      });

      return Promise.reject(error);
    } finally {
      dispatch(callLoader(false));
    }
    };
  
    // ======================================
    // DELETE
    // ======================================
    
    export const deleteBaseModule = (payload) => async (dispatch) => {
      try {
        dispatch(callLoader(true));
    
        const url = `v1/ModuleSetup/DeleteBaseModule`;
    
        const result = await APICall("post", payload, url, {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
        });
    
        if (result?.statuscode === 200 || result?.statuscode === 201) {
          dispatch({
            type: BASE_MODULE_DELETE,
            payload: payload?.BASEMODULE_ID,
          });
    
          return result;
        }
    
        return Promise.reject(result);
      } catch (error) {
        logApiError(error, {
          source: "deleteBaseModule",
          endpoint: "DeleteBaseModule",
          payload,
        });
    
        return Promise.reject(error);
      } finally {
        dispatch(callLoader(false));
      }
    };